import styled from 'styled-components'
import { theme, VerticalSpacer } from '@superhi/design'

export const Wrapper = styled(VerticalSpacer).attrs({
  amount: { small: 16, medium: 16, large: 24 },
})`
  background-color: ${theme.colors.PALE_BLUE_50};
  padding: 24px;
  border-radius: 10px;
`
